import {observer} from 'mobx-react';
import {DatePicker, EmailTemplatePreview, FormLayout} from 'shared/components';
import {Modal, ModalButtons} from 'shared/components/modals';
import {FormattedMessage} from 'react-intl';
import {calendarDate} from 'shared/tools';

const LaunchModal = observer(({uiState}) => {
  const {cycle, scheduledLaunch, errors} = uiState;

  return (
    <Modal
      title='performance_reviews.manage.Launch Reviews'
      description='performance_reviews.manage.REVIEW_LAUNCH_DESCRIPTION'
      isOpen={uiState.launchCycleModalOpen}
      onHide={() => uiState.closeLaunchCycleModal()}
      size='md'
    >
      <FormLayout>
        <DatePicker
          label='performance_reviews.manage.Launch date'
          value={cycle.launchDate}
          onChange={(date) => cycle.merge({launchDate: date})}
          options={{startDate: '0'}}
          className='full-width'
          errorMessage={errors.launchDate}
        />
        <DatePicker
          label='performance_reviews.manage.Due date'
          value={cycle.dueDate}
          onChange={(date) => cycle.merge({dueDate: date})}
          options={{startDate: '0'}}
          className='full-width'
          errorMessage={errors.dueDate}
        />
        <div>
          <div>
            <FormattedMessage id='performance_reviews.manage.Launch email preview'/>
          </div>
          <div className='pb2 jumbo'>
            <FormattedMessage id={scheduledLaunch ? 'performance_reviews.manage.SCHEDULED_NUMBER_OF_REVIEWERS' : 'performance_reviews.manage.NUMBER_OF_REVIEWERS'} values={{reviewerCount: cycle.reviewersCount, date: calendarDate(cycle.launchDate)}}/>
          </div>
          <EmailTemplatePreview template={uiState.emailPreview}/>
        </div>
        <ModalButtons
          saveCaption={scheduledLaunch ? 'performance_reviews.manage.Schedule Reviews' : 'performance_reviews.manage.Launch Reviews'}
          onSave={() => uiState.launchCycle()}
          onCancel={() => uiState.closeLaunchCycleModal()}
          enabled={!uiState.isLaunching}
        />
      </FormLayout>
    </Modal>
  );
});

export default LaunchModal;
